import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { Button } from '@eatclubcode/ec-component-library';

export const RoundButton = ({ children = null, style = {}, onClick = () => {}, ...other }) => {
  const theme = useTheme();
  return (
    <Button
      style={{
        ...style,
        button: {
          backgroundColor: 'transparent',
          height: '40px',
          padding: '4px 20px 6px 20px',
          border: `1px solid ${theme.colors.charcoal}`,
          borderRadius: '1000px',
          fontWeight: theme.fontWeights.medium,
          boxShadow: 'none',
          color: theme.colors.charcoal,
          lineHeight: 'unset',
          minWidth: '100px',
          // eslint-disable-next-line react/prop-types
          ...style?.button,
        },
        buttonHover: {
          backgroundColor: 'white',
          color: 'black',
          border: `1px solid black`,
          filter: 'none',
          // eslint-disable-next-line react/prop-types
          ...style?.buttonHover,
        },
        text: {
          verticalAlign: 'middle',
          // eslint-disable-next-line react/prop-types
          ...style?.text,
        },
      }}
      onClick={onClick}
      {...other}
    >
      {children}
    </Button>
  );
};

RoundButton.propTypes = {
  children: PropTypes.node,
  style: PropTypes.shape({}),
  onClick: PropTypes.func,
};
